import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RenderInTargetComponentBase } from 'common-ui';

@Component({
  selector: 'ideal-render-target-app-primary-menu',
  standalone: true,
  imports: [NgTemplateOutlet],
  template: ` @for (item of renderItems(); track item) {
    <ng-container
      [ngTemplateOutlet]="item.template"
      [ngTemplateOutletContext]="getItemContext(item, $index)"
      [ngTemplateOutletInjector]="item.injector"
    ></ng-container>
  }`,
  styles: `
    :host {
      display: block;
      height: 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppPrimaryMenuRenderTargetComponent extends RenderInTargetComponentBase {
  public override get context() {
    return undefined;
  }
}
